import React from "react";

function CardPlayer({ player }) {
  return (
    <div className="card-player">
      <TopCardPlayer player={player} />
      <MidCardPlayer player={player} />
      <BotCardPlayer player={player} />
    </div>
  );
}

function TopCardPlayer({ player }) {
    return (<div className="top-card-player">
            <div>
                <div className="image-champion-player">
                    <img src={`https://ddragon.leagueoflegends.com/cdn/${player.shortPatch}.1/img/champion/${player.championId}.png`} alt={`${player.championId}`} />
                </div>
                <div className="level-player">
                    <p>{player.level}</p>
                </div>
            </div>
            <div>
                <p className="pseudo-top-card-player">{player.summonerName}</p>
                <p>{player.championId} - {player.role}</p>
                <p className="kda-top-card-player">{player.kills} / {player.deaths} / {player.assists}</p>
            </div>
            <div>
                <div className="image-irl-player">
                    <img src="https://static.wikia.nocookie.net/lolesports_gamepedia_en/images/9/9d/BFX_Diable_2025_Split_1.png/revision/latest?cb=20250228143157" alt="Joueur Diable" />
                </div>
            </div>
        
        </div>)
}

function MidCardPlayer({ player }) {
    return (<div className="mid-card-player">
            <div className="hp-container" >
                <div className="hp-fill" style={{ width: `${Math.round(player.currentHealth / player.maxHealth * 100)}%` }}></div>
                <p className="hp-text">{player.currentHealth}/{player.maxHealth}</p>
            </div>
                <div className="main-stats-player">
                    <div>
                        <p>{player.totalGoldEarned} <span className="stats-unite">gold</span></p>
                    </div>
                    <div>
                        <p>{player.creepScore} <span className="stats-unite">CS</span></p>
                    </div>
                    <div>
                        <p>{Math.round(player.killParticipation * 100)} % <span className="stats-unite">KP</span></p>
                    </div>
                    <div>
                        <p>{Math.round(player.championDamageShare * 100)} % <span className="stats-unite">répartition dégâts</span></p>
                    </div>
                    <div>
                        <p>{player.wardsPlaced}/{player.wardsDestroyed} <span className="stats-unite">balises posées/détruites</span></p>
                    </div>
                    
                </div>
        </div>)
}

function BotCardPlayer({ player }){
    return(
        <div className="bot-card-player">
            <div className="secondary-stats-player">
                <div>
                    <p>{player.attackDamage} <span className="stats-unite">AD</span></p>
                </div>
                <div>
                    <p>{player.lifeSteal} <span className="stats-unite">Vol de vie</span></p>
                </div>
                <div>
                    <p>{player.abilityPower} <span className="stats-unite">AP</span></p>
                </div>
                <div>
                    <p>{player.armor} <span className="stats-unite">Armure</span></p>
                </div>
                <div>
                    <p>{player.attackSpeed} <span className="stats-unite">vitesse d'attaque</span></p>
                </div>
                <div>
                    <p>{player.magicResistance} <span className="stats-unite">résistance magique</span></p>
                </div>
                
            </div>
        </div>
    )
}


export default CardPlayer;
